import {fromJS} from 'immutable';
import {generatePlaceholderMessage} from '../../Helpers/utils'
import {
  STARTING_COMPLETION,
  RECEIVE_TEXT_STREAM,
  SET_ANIMATION,
  SET_END_OF_STREAM,
  SET_IS_PHOTO_CAPTURE_OPEN,
  SET_CAPTURED_IMAGE,
  SET_PHOTO_CAPTURE_WIZARD_STEP,
  SET_WHOS_IN_THE_PHOTO,
  SET_SHOW_PHOTO_IS_OPEN,
  SET_PLACEHOLDER_MESSAGE,
  GET_GENERAL_META_DATA_RESULT,
  RECEIVE_TEXT_STREAM_REFLECTED,
  SET_END_OF_STREAM_REFLECTED,
  SET_SHOULD_FOCUS_SEND_BUTTON,
  SET_SHOULD_FOCUS_INPUT_FIELD,
} from './consts'

const initialState = fromJS({
  chat: [],
  reflectedChat: [],
  animation: 0,
  generalMetaData: {},
  botName: '',
  isPhotoCaptureOpen: false,
  photoCaptureWizardStep: 0,
  capturedImage: null,
  whoIsInThePhoto: '',
  isShowPhotoOpen: false,
  showPhotoUrl: '',
  placeHolderMessage: generatePlaceholderMessage(),
  sessionId: null,
  shouldFocusSendButton: false,
  shouldFocusInputField: false,
})

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  let word, predictionUUID, endOfStream, meta, topN, selectedTopNIndex, isTopNPanelOpen

  switch (action.type) {

    case STARTING_COMPLETION:
      const prompt = '['+action.prompt.trim()+']\n'
      return state.update('chat', chat => chat.push(fromJS({role: 'user', text: prompt})))
        .update('reflectedChat', chat => chat.push(fromJS({role: 'user', text: prompt})))

    case RECEIVE_TEXT_STREAM:
      ({word, predictionUUID,meta} = action)
      return state.update('chat', chat => {
        const lastIndex = chat.findLastIndex(entry => entry.get('predictionUUID') === predictionUUID);
        meta.forEach(item => {
          item.index = lastIndex === -1 ? 0 : chat.get(lastIndex).get('text').length
        });
        if (lastIndex !== -1) {
          return chat.update(lastIndex, entry =>
            entry.set('text', entry.get('text') + word)
              .set('meta', entry.get('meta').concat(meta)))
        } else {
          return chat.push(fromJS({role: 'assistant', text: word, predictionUUID, meta}));
        }
      })

    case RECEIVE_TEXT_STREAM_REFLECTED:
      ({word = '', predictionUUID, meta, topN = null, selectedTopNIndex = -1, isTopNPanelOpen = null} = action)
      return state.update('reflectedChat', reflectedChat => {
        const lastIndex = reflectedChat.findLastIndex(entry => entry.get('predictionUUID') === predictionUUID);
        if (lastIndex !== -1) {
          return reflectedChat.update(lastIndex, entry => {
            entry = entry.set('text', entry.get('text') + word)
            entry = entry.set('meta', meta)
            if (topN) entry = entry.set('topN', topN)
            if (selectedTopNIndex>-1) entry = entry.set('selectedTopNIndex', selectedTopNIndex)
            if (isTopNPanelOpen!==null) entry = entry.set('isTopNPanelOpen', isTopNPanelOpen)
            return entry
          })
        } else {
          return reflectedChat.push(fromJS({role: 'assistant', text: word, predictionUUID, meta, topN, isTopNPanelOpen, selectedTopNIndex})).set('animation', 0)
        }
      }).set('animation', 0)

    case SET_ANIMATION:
      return state.set('animation', action.payload)

    case SET_END_OF_STREAM:
      ({endOfStream, predictionUUID} = action)
      return state.update('chat', chat => {
        const index = chat.findIndex(entry => entry.get('predictionUUID') === predictionUUID);
        if (index !== -1) {
          return chat.update(index, entry => entry.set('endOfStream', endOfStream));
        }
        return chat;
      })

    case SET_END_OF_STREAM_REFLECTED:
      ({endOfStream, predictionUUID} = action)
      return state.update('reflectedChat', chat => {
        const index = chat.findIndex(entry => entry.get('predictionUUID') === predictionUUID);
        if (index !== -1) {
          return chat.update(index, entry => entry.set('endOfStream', endOfStream));
        }
        return chat;
      })

    case GET_GENERAL_META_DATA_RESULT:
      const {botName} = action.payload
      return state.set('generalMetaData', fromJS(action.payload))
        .set('botName', botName)

    case SET_IS_PHOTO_CAPTURE_OPEN:
      return state.set('isPhotoCaptureOpen', action.isOpen)

    case SET_CAPTURED_IMAGE:
      return state.set('capturedImage', action.image)

    case SET_PHOTO_CAPTURE_WIZARD_STEP:
      return state.set('photoCaptureWizardStep', action.step)

    case SET_WHOS_IN_THE_PHOTO:
      return state.set('whoIsInThePhoto', action.text)

    case SET_SHOW_PHOTO_IS_OPEN:
      return state.set('isShowPhotoOpen', action.isOpen)
        .set('showPhotoUrl', action.url)

    case SET_PLACEHOLDER_MESSAGE:
      return state.set('placeHolderMessage', action.message)

    case SET_SHOULD_FOCUS_SEND_BUTTON:
      return state.set('shouldFocusSendButton', action.shouldFocus)

    case SET_SHOULD_FOCUS_INPUT_FIELD:
      return state.set('shouldFocusInputField', action.shouldFocus)

    default:
      return state;
  }
}
;
